
import { RetailersFilterPage } from "../retailerFilter/RetailerFilterPage";
import { RetailerTablePage } from "../retailerTable/RetailerTablePage";


import classes from "./retailerListPage.module.css";


export const RetailerListPage = () => {
 

  return  (
    <div className={classes.box}>
      <RetailersFilterPage />
      <RetailerTablePage  />
    </div>
  ) 
};
